import { StatusDetailsInfo } from '../interfaces/statusDetails';
import { apiService } from '../../shared/services/apiService';

export const entityStatusService = {
  async getNutritionStatusDetails(entityId: number) {
    const resp = await apiService.get<StatusDetailsInfo>(
      `/api/entity/${entityId}/status/nutrition/details`,
    );

    return resp.data;
  },

  async getScanIqStatusDetails(entityId: number) {
    const resp = await apiService.get<StatusDetailsInfo>(
      `/api/entity/${entityId}/status/scan-iq/details`,
    );

    return resp.data;
  },

  async getChallengeStatusDetails(entityId: number) {
    const resp = await apiService.get<StatusDetailsInfo>(
      `/api/entity/${entityId}/status/challenge/details`,
    );

    return resp.data;
  },

  /** @deprecated return nutrition status details, same as getNutritionStatusDetails */
  async getStatusDetails(entityId: number) {
    const resp = await apiService.get<StatusDetailsInfo>(
      `/api/entity/${entityId}/status/details`,
    );

    return resp.data;
  },
};
